<template>
  <div class="form-signin col-md-4 mx-auto mt-5 text-center">
    <img
      class="mb-4"
      src="../../assets/img/deepify.png"
      alt=""
      width="72"
      height="72"
    >
    <h1 class="h3 mb-3 font-weight-normal">
      Please sign up
    </h1>
    <label
      for="inputFullName"
      class="sr-only"
    >Full name</label>
    <input
      id="inputFullName"
      v-model="fullName"
      type="text"
      class="form-control mb-1"
      placeholder="Full name"
      required=""

      autofocus=""
    >
    <label
      for="inputCompany"
      class="sr-only"
    >Company name</label>
    <input
      id="inputCompany"
      v-model="companyName"
      type="text"
      class="form-control mb-1"
      placeholder="Company name"
      required=""

      autofocus=""
    >
    <label
      for="inputEmail"
      class="sr-only"
    >Email address</label>
    <input
      id="inputEmail"
      v-model="email"
      type="email"
      class="form-control mb-1"
      placeholder="Email address"

      required=""
    >
    <label
      for="inputPassword"
      class="sr-only"
    >Password</label>
    <input
      id="inputPassword"
      v-model="password"
      type="password"
      class="form-control mb-3"
      placeholder="Password"

      required=""
    >
    <button
      class="btn btn-lg btn-dark btn-block mb-2"
      type="submit"

      @click="register"
    >
      Sign up
    </button>
    <small>or</small>
    <router-link
      to="/login"
      class="button button--link button--link-primary"
    >
      <h6 class="mt-2 text-dark">
        Already have an account? <b>Log in</b>
      </h6>
    </router-link>
    <p class="mt-5 mb-3 text-muted">
      © 2019
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      fullName: '',
      companyName: '',
      email: '',
      password: '',
    };
  },
  methods: {
    ...mapActions([
      'doSignUp',
    ]),
    register() {
      if (this.fullName && this.email && this.password) {
        this.doSignUp({
          full_name: this.fullName,
          company: {
            name: this.companyName,
          },
          email: this.email,
          password: this.password,
        });
      }
    },
  },
};
</script>
